import React from "react";
import { Link } from "@tanstack/react-router";
import { ExternalLink } from "lucide-react";
import { Button } from "~/components/ui/button";
import { hasError } from "~/lib/form";
import type { FieldValues, FormState } from "react-hook-form";

export interface ProfileEditHeaderProps {
  title: string;
  description?: string;
  form?: FormState<FieldValues>;
  username: string;
  children?: React.ReactNode;
}

export const ProfileEditHeader = ({
  title,
  description,
  form,
  username,
  children,
}: ProfileEditHeaderProps) => {
  return (
    <div className="sticky top-0 z-40 flex h-16 items-center justify-end gap-4 bg-white/50 backdrop-blur-lg">
      <div className="grow">
        <h1 className="font-heading text-text-primary text-2xl">{title}</h1>
        {description && (
          <p className="text-text-secondary text-sm">{description}</p>
        )}
      </div>
      {form && hasError(form) && (
        <div className="text-xs text-red-700">
          Please fix the errors below before saving.
        </div>
      )}
      <Link to="/$username" params={{ username }} target="_blank">
        <Button
          variant="outline"
          type="button"
          className="flex shrink-0 items-center gap-2"
        >
          View Profile <ExternalLink />
        </Button>
      </Link>
      {form && (
        <Button
          disabled={!form.isDirty || form.isSubmitting || hasError(form)}
          type="submit"
          className="shrink-0"
        >
          {form.isSubmitting ? "Saving..." : "Save"}
        </Button>
      )}
      {children}
    </div>
  );
};
